// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-modal {
  width: 100%;
  background-image: linear-gradient(#0d0d0d, #080808);
  margin: 0px auto 0px !important;
  padding: 1.2vw 1.5vw !important;
  border-top-left-radius: 0.5vw !important;
  border-top-right-radius: 0.5vw !important;
}

.form-header {
  font-family: "Poppins" !important;
  font-weight: 300 !important;
  font-size: 1.1vw !important;
  line-height: 100% !important;
  color: white !important;
  padding-bottom: 0.5vw !important;
}

.modal-limit {
  max-height: 30vw !important;
  overflow-y: scroll !important;
  margin-bottom: 0.3vw !important;
}

/* input */
.input-box-label {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.9vw !important;
  line-height: 100% !important;
  color: #595959 !important;
  margin-bottom: 0.3vw !important;
  outline: none !important;
  text-transform: capitalize;
}

.input-box,
.custom-phone-input {
  background-color: transparent !important;
  border: 0.05vw solid #595959 !important;
  height: 2.3vw;
  border-radius: 0.4vw;
  width: 100% !important;
  padding-left: 1vw !important;
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
  color: white !important;
  &:focus {
    outline: none !important;
  }
}

.input-box::placeholder {
  color: #595959;
  font-size: 0.8vw;
  font-family: Poppins;
  font-weight: 500;
}

.error-input-box {
  background-color: transparent !important;
  border: 0.05vw solid #f23d3d !important;
  height: 2.3vw;
  border-radius: 0.4vw;
  width: 100% !important;
  padding-left: 1vw !important;
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
  /* margin-bottom: 5px !important;   */
  color: white !important;
  &:focus {
    outline: none !important;
  }
}

.error-input-box::placeholder {
  color: #595959;
  font-size: 0.8vw;
  font-family: Poppins;
  font-weight: 500;
}

.error-message {
  color: #f23d3d !important;
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.55vw !important;
  line-height: 100% !important;
}

.search-container {
  border: 0.05vw solid #595959 !important;
  border-radius: 0.4vw;
  padding-left: 0.8vw !important;
}

.error-search-container {
  border: 0.05vw solid #f23d3d !important;
  border-radius: 0.4vw;
  padding-left: 0.8vw !important;
}

.search-form-input {
  background-color: transparent;
  height: 2.3vw;
  width: 100% !important;
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
  color: white !important;
  border: none !important;
  padding-left: 0.4vw !important;
  outline: none !important;
  /* text-transform: capitalize; */
  &:focus {
    outline: none !important;
    border: none !important;
  }
}

.search-form-input::placeholder {
  color: #595959;
  font-size: 0.8vw;
  font-family: Poppins;
  font-weight: 500;
}

.clear-icon {
  /* height: 1vw !important; */
  padding-right: 0.8vw !important;
  cursor: pointer !important;
  /* opacity: 0.6 !important; */
}

/* .search-icon {
  padding-top: .25vw;
} */

.input-box::placeholder,
.search-input::placeholder {
  font-size: 0.8vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 100% !important;
}

.new-client {
  height: 1.4vw !important;
  border-radius: 0.15vw !important;
  border: 0.5px solid #50c878 !important;
  padding: 0.25vw 0.5vw !important;
  &:hover {
    background-color: #50c8782d;
  }
}

.new-client-text {
  color: #50c878 !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 0.6vw !important;
  line-height: 100% !important;
  text-transform: capitalize;
}

.input-btn {
  height: 1.75vw !important;
  width: 1.75vw !important;
  background-color: transparent;
  border: 0.05vw solid #50c878;
  border-radius: 0.15vw;
  color: #50c878;
  cursor: pointer;
  /* margin-bottom: 6px; */
  &:hover {
    background-color: #50c8782d;
  }
}

.add-btn {
  height: 1.75vw !important;
  width: 1.75vw !important;
  background-color: transparent;
  border: 0.05vw solid #50c878;
  border-radius: 0.15vw;
  color: #50c878;
  cursor: pointer;
  font-size: 0.75vw;
  /* margin-bottom: 6px; */
  &:hover {
    background-color: #50c8782d;
  }
}

.delete-btn {
  height: 1.75vw !important;
  width: 1.75vw !important;
  background-color: transparent;
  border: 0.05vw solid #f23d3d;
  border-radius: 0.15vw;
  color: #f23d3d;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-bottom: .3vw;  */
  &:hover {
    background-color: #f23d3d3b;
  }
}

.contBtn {
  background-color: #50c878 !important;
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  width: 100%;
  height: 2.5vw;
  font-size: 0.9vw !important;
  line-height: 100% !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: 0.5vw !important;
  border-bottom-right-radius: 0.5vw !important;
}

/*menuItem*/
.suggestions-dropdown {
  background-color: white !important;
  padding: 0.1vw;
  border-radius: 0.6vw !important;
  margin-top: 0.1vw;
  overflow-y: auto;
  max-height: 8vw;
}

.suggestion-item {
  color: black;
  /* height: 2.25vw !important; */
  height: auto !important;

  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.8vw !important;
  line-height: 1.1vw !important;
  letter-spacing: -0.41px !important;
  margin: 0.1vw !important;
  padding: 0.6vw 0 0.5vw 0.5vw !important;
}
.suggestion-item:hover {
  /* background-color: #262626 !important; */
  margin: 0.1vw !important;
  /* color: white !important; */
  border-radius: 0.45vw !important;
}

.suggestion-item.active-suggestion {
  background-color: #262626 !important;
  margin: 0.1vw !important;
  color: white !important;
  border-radius: 0.45vw !important;
}

/*react phone-input 2*/
.react-tel-input {
  position: relative !important;
}
.react-tel-input .form-control {
  padding-left: 3vw !important;
}

.react-tel-input .country-list {
  background-color: white !important;
  color: black !important;
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.8vw !important;
  line-height: 1.1vw !important;
  letter-spacing: -0.41px !important;
  margin: 0.9vw 0.4vw 0 -0.2vw !important;
}

.react-tel-input .selected-flag {
  padding: 0 1.8vw 0 0.4vw !important;
  &:hover {
    background-color: transparent !important;
  }
}

.react-tel-input .flag-dropdown.open .selected-flag {
  background-color: transparent !important;
}

.react-tel-input .country-list .country:hover {
  background-color: #262626 !important;
  margin: 0.1vw !important;
  color: white !important;
  border-radius: 0.45vw !important;
}

/* .phone-dropdown {
    position: absolute !important;
    top: 25px !important;
    left: 1px !important;
    padding: 10px !important;
    z-index: 99999 !important; 
     border-radius:8px !important ;
} */

/* phone-input */
/* .PhoneInputInput{
    height: 20px !important;
    background-color: transparent;
    border: none;
    color:white !important;
    border-left :2px solid white !important;
    margin:10px 2px !important;
    padding:0px 10px !important;
    &::placeholder {
    font-size: 16px !important;
    font-family: "Poppins" !important;
    font-weight: 500 !important;
    line-height: 100% !important;
    }
    &:focus{
        outline: none !important;
    }
} */

/* height: 200px !important; */
/* width:320px !important; */
/* .PhoneInputCountrySelect {
    border:2px solid red !important;
    border-radius: 8px; 
    font-family: "Poppins" !important;
    font-size: 16px;
    max-height: 200px !important;
    overflow-y: auto !important;
    background: #333 !important;
}

.PhoneInputCountrySelect > option {

    border:2px solid red !important;
    font-family: "Poppins" !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    letter-spacing: -0.41px !important;
} */

/* .PhoneInputCountrySelectDropdown {
    max-height: 200px !important;
    overflow-y: auto !important;
    background: #333 !important;
  } */
`, "",{"version":3,"sources":["webpack://./src/components/ui/clientForm/clientFormStyle.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mDAAmD;EACnD,+BAA+B;EAC/B,+BAA+B;EAC/B,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;;EAEE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;;EAEvB,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;;;;;;GAOG;;AAEH,gBAAgB;AAChB;;;;;;;;;;;;;;;;;GAiBG;;AAEH,8BAA8B;AAC9B,4BAA4B;AAC5B;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;;;;KAIK","sourcesContent":[".form-modal {\n  width: 100%;\n  background-image: linear-gradient(#0d0d0d, #080808);\n  margin: 0px auto 0px !important;\n  padding: 1.2vw 1.5vw !important;\n  border-top-left-radius: 0.5vw !important;\n  border-top-right-radius: 0.5vw !important;\n}\n\n.form-header {\n  font-family: \"Poppins\" !important;\n  font-weight: 300 !important;\n  font-size: 1.1vw !important;\n  line-height: 100% !important;\n  color: white !important;\n  padding-bottom: 0.5vw !important;\n}\n\n.modal-limit {\n  max-height: 30vw !important;\n  overflow-y: scroll !important;\n  margin-bottom: 0.3vw !important;\n}\n\n/* input */\n.input-box-label {\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.9vw !important;\n  line-height: 100% !important;\n  color: #595959 !important;\n  margin-bottom: 0.3vw !important;\n  outline: none !important;\n  text-transform: capitalize;\n}\n\n.input-box,\n.custom-phone-input {\n  background-color: transparent !important;\n  border: 0.05vw solid #595959 !important;\n  height: 2.3vw;\n  border-radius: 0.4vw;\n  width: 100% !important;\n  padding-left: 1vw !important;\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n  color: white !important;\n  &:focus {\n    outline: none !important;\n  }\n}\n\n.input-box::placeholder {\n  color: #595959;\n  font-size: 0.8vw;\n  font-family: Poppins;\n  font-weight: 500;\n}\n\n.error-input-box {\n  background-color: transparent !important;\n  border: 0.05vw solid #f23d3d !important;\n  height: 2.3vw;\n  border-radius: 0.4vw;\n  width: 100% !important;\n  padding-left: 1vw !important;\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n  /* margin-bottom: 5px !important;   */\n  color: white !important;\n  &:focus {\n    outline: none !important;\n  }\n}\n\n.error-input-box::placeholder {\n  color: #595959;\n  font-size: 0.8vw;\n  font-family: Poppins;\n  font-weight: 500;\n}\n\n.error-message {\n  color: #f23d3d !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 400 !important;\n  font-size: 0.55vw !important;\n  line-height: 100% !important;\n}\n\n.search-container {\n  border: 0.05vw solid #595959 !important;\n  border-radius: 0.4vw;\n  padding-left: 0.8vw !important;\n}\n\n.error-search-container {\n  border: 0.05vw solid #f23d3d !important;\n  border-radius: 0.4vw;\n  padding-left: 0.8vw !important;\n}\n\n.search-form-input {\n  background-color: transparent;\n  height: 2.3vw;\n  width: 100% !important;\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n  color: white !important;\n  border: none !important;\n  padding-left: 0.4vw !important;\n  outline: none !important;\n  /* text-transform: capitalize; */\n  &:focus {\n    outline: none !important;\n    border: none !important;\n  }\n}\n\n.search-form-input::placeholder {\n  color: #595959;\n  font-size: 0.8vw;\n  font-family: Poppins;\n  font-weight: 500;\n}\n\n.clear-icon {\n  /* height: 1vw !important; */\n  padding-right: 0.8vw !important;\n  cursor: pointer !important;\n  /* opacity: 0.6 !important; */\n}\n\n/* .search-icon {\n  padding-top: .25vw;\n} */\n\n.input-box::placeholder,\n.search-input::placeholder {\n  font-size: 0.8vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 100% !important;\n}\n\n.new-client {\n  height: 1.4vw !important;\n  border-radius: 0.15vw !important;\n  border: 0.5px solid #50c878 !important;\n  padding: 0.25vw 0.5vw !important;\n  &:hover {\n    background-color: #50c8782d;\n  }\n}\n\n.new-client-text {\n  color: #50c878 !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 0.6vw !important;\n  line-height: 100% !important;\n  text-transform: capitalize;\n}\n\n.input-btn {\n  height: 1.75vw !important;\n  width: 1.75vw !important;\n  background-color: transparent;\n  border: 0.05vw solid #50c878;\n  border-radius: 0.15vw;\n  color: #50c878;\n  cursor: pointer;\n  /* margin-bottom: 6px; */\n  &:hover {\n    background-color: #50c8782d;\n  }\n}\n\n.add-btn {\n  height: 1.75vw !important;\n  width: 1.75vw !important;\n  background-color: transparent;\n  border: 0.05vw solid #50c878;\n  border-radius: 0.15vw;\n  color: #50c878;\n  cursor: pointer;\n  font-size: 0.75vw;\n  /* margin-bottom: 6px; */\n  &:hover {\n    background-color: #50c8782d;\n  }\n}\n\n.delete-btn {\n  height: 1.75vw !important;\n  width: 1.75vw !important;\n  background-color: transparent;\n  border: 0.05vw solid #f23d3d;\n  border-radius: 0.15vw;\n  color: #f23d3d;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-bottom: .3vw;  */\n  &:hover {\n    background-color: #f23d3d3b;\n  }\n}\n\n.contBtn {\n  background-color: #50c878 !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  width: 100%;\n  height: 2.5vw;\n  font-size: 0.9vw !important;\n  line-height: 100% !important;\n  border-top-left-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n  border-bottom-left-radius: 0.5vw !important;\n  border-bottom-right-radius: 0.5vw !important;\n}\n\n/*menuItem*/\n.suggestions-dropdown {\n  background-color: white !important;\n  padding: 0.1vw;\n  border-radius: 0.6vw !important;\n  margin-top: 0.1vw;\n  overflow-y: auto;\n  max-height: 8vw;\n}\n\n.suggestion-item {\n  color: black;\n  /* height: 2.25vw !important; */\n  height: auto !important;\n\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.8vw !important;\n  line-height: 1.1vw !important;\n  letter-spacing: -0.41px !important;\n  margin: 0.1vw !important;\n  padding: 0.6vw 0 0.5vw 0.5vw !important;\n}\n.suggestion-item:hover {\n  /* background-color: #262626 !important; */\n  margin: 0.1vw !important;\n  /* color: white !important; */\n  border-radius: 0.45vw !important;\n}\n\n.suggestion-item.active-suggestion {\n  background-color: #262626 !important;\n  margin: 0.1vw !important;\n  color: white !important;\n  border-radius: 0.45vw !important;\n}\n\n/*react phone-input 2*/\n.react-tel-input {\n  position: relative !important;\n}\n.react-tel-input .form-control {\n  padding-left: 3vw !important;\n}\n\n.react-tel-input .country-list {\n  background-color: white !important;\n  color: black !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.8vw !important;\n  line-height: 1.1vw !important;\n  letter-spacing: -0.41px !important;\n  margin: 0.9vw 0.4vw 0 -0.2vw !important;\n}\n\n.react-tel-input .selected-flag {\n  padding: 0 1.8vw 0 0.4vw !important;\n  &:hover {\n    background-color: transparent !important;\n  }\n}\n\n.react-tel-input .flag-dropdown.open .selected-flag {\n  background-color: transparent !important;\n}\n\n.react-tel-input .country-list .country:hover {\n  background-color: #262626 !important;\n  margin: 0.1vw !important;\n  color: white !important;\n  border-radius: 0.45vw !important;\n}\n\n/* .phone-dropdown {\n    position: absolute !important;\n    top: 25px !important;\n    left: 1px !important;\n    padding: 10px !important;\n    z-index: 99999 !important; \n     border-radius:8px !important ;\n} */\n\n/* phone-input */\n/* .PhoneInputInput{\n    height: 20px !important;\n    background-color: transparent;\n    border: none;\n    color:white !important;\n    border-left :2px solid white !important;\n    margin:10px 2px !important;\n    padding:0px 10px !important;\n    &::placeholder {\n    font-size: 16px !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 500 !important;\n    line-height: 100% !important;\n    }\n    &:focus{\n        outline: none !important;\n    }\n} */\n\n/* height: 200px !important; */\n/* width:320px !important; */\n/* .PhoneInputCountrySelect {\n    border:2px solid red !important;\n    border-radius: 8px; \n    font-family: \"Poppins\" !important;\n    font-size: 16px;\n    max-height: 200px !important;\n    overflow-y: auto !important;\n    background: #333 !important;\n}\n\n.PhoneInputCountrySelect > option {\n\n    border:2px solid red !important;\n    font-family: \"Poppins\" !important;\n    font-weight: 600 !important;\n    font-size: 16px !important;\n    line-height: 22px !important;\n    letter-spacing: -0.41px !important;\n} */\n\n/* .PhoneInputCountrySelectDropdown {\n    max-height: 200px !important;\n    overflow-y: auto !important;\n    background: #333 !important;\n  } */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
